import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_TITLE = 'Corenova | Renewable Energy & Solar Installations Odisha';
const DEFAULT_DESC = 'Corenova brings fast, hassle‑free solar installations across Odisha. expert consultation to 24/7 support, powering homes and businesses toward zero electricity bills.';
const DEFAULT_IMAGE = 'https://corenovarenewable.com/images/2.png';
const DEFAULT_URL = 'https://corenovarenewable.com/';

const SEO = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESC,
  canonical = DEFAULT_URL,
  image = DEFAULT_IMAGE,
  keywords = 'renewable energy, solar, wind, hydro, energy storage, India, Corenova',
  type = 'website',
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="keywords" content={keywords} />
    <link rel="canonical" href={canonical} />

    <meta property="og:type" content={type} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={image} />
    <meta property="og:url" content={canonical} />
    <meta property="og:site_name" content="CoreNova Renewable Energy" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />
  </Helmet>
);

export default SEO; 